import { render, staticRenderFns } from "./NavBack.vue?vue&type=template&id=7ff764c8&"
import script from "./NavBack.vue?vue&type=script&lang=js&"
export * from "./NavBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports